import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Icon from "@mui/material/Icon";
// @mui/icons-material
import Search from "@mui/icons-material/Search";
import Email from "@mui/icons-material/Email";
import Face from "@mui/icons-material/Face";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Explore from "@mui/icons-material/Explore";
// core components
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import Header from "../../components/Header/Header.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown.js";
import Button from "../../components/CustomButtons/Button.js";

import styles from "../../styles/jss/nextjs-material-kit/pages/componentsSections/jobsDynamicSearchStyle.js";

const useStyles = makeStyles()(styles);

export default function OrgSortBar({ sortChosen }) {
  const { classes, cx } = useStyles();
  return (
    <GridContainer className="justify-content-md-center">
      <GridItem
        xs={12}
        sm={12}
        md={12}
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <List className={classes.list}>
          <ListItem className={classes.listItem}>
            <CustomDropdown
              buttonText="Sort"
              buttonProps={{
                className: cx(classes.dropDown, classes.btnCustomDropdown),
              }}
              dropdownList={[
                "Top",
                "A-Z",
              ]}
              onClick={sortChosen}
            />
          </ListItem>
        </List>
      </GridItem>
    </GridContainer>
  );
}

OrgSortBar.propTypes = {
  sortChosen: PropTypes.func.isRequired,
}
